import { useIsBlockchainVersion } from './useIsBlockchainVersion.ts';
import { usePreviousGameRoundBlockchainResults } from './usePreviousGameRoundBlockchainResults.ts';
import { usePreviousGameRoundWebsocketResults } from './usePreviousGameRoundWebsocketResults.ts';

// TODO: check why it's not in use anymore
export const usePreviousGameRoundResults = () => {
  const blockchainVersion = useIsBlockchainVersion();
  const websocketResults =
    usePreviousGameRoundWebsocketResults(!blockchainVersion);
  const blockchainResults =
    usePreviousGameRoundBlockchainResults(blockchainVersion);
  return blockchainVersion ? blockchainResults : websocketResults;
};

export type UsePreviousGameRoundResultsHookResult = ReturnType<
  typeof usePreviousGameRoundResults
>;
